import { connect } from 'react-redux';
import * as qualificationsActions from '../../redux/actions/qualificationsActions';

export default (WrappedComponent) => connect(null, qualificationsActions)(WrappedComponent);
